import { render, staticRenderFns } from "./FaceDirectionTracker.vue?vue&type=template&id=1375b61a&scoped=true&"
import script from "./FaceDirectionTracker.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionTracker.vue?vue&type=script&lang=ts&"
import style0 from "./FaceDirectionTracker.vue?vue&type=style&index=0&id=1375b61a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1375b61a",
  null
  
)

export default component.exports